import { MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";
import { DeepMap, FieldError } from "react-hook-form";

import { generateId } from "../../utils/ids/generateId";
import { getDeepValue } from "../../utils/objects/getDeepValue";

interface FormErrorMessageProp {
    errors: DeepMap<Record<string, unknown>, FieldError>;
    name: string;
    testId?: string;
    children?: React.ReactNode;
    renderMessage?(error: FormError): JSX.Element;
}

export interface FormError {
    id: string;
    message: string;
    code?: string;
}

export const FormErrorMessage: React.FunctionComponent<FormErrorMessageProp> = (props: FormErrorMessageProp) => {
    const errorList = getErrors(getDeepValue(props.errors, props.name)?.message);

    return (
        <>
            {errorList.map(({ id, message, code }) => (
                <MessageBar
                    key={id}
                    messageBarType={MessageBarType.error}
                    isMultiline={true}
                    data-testid={props.testId}
                >
                    {props.renderMessage ? props.renderMessage({ id, message, code }) : message}
                </MessageBar>
            ))}
        </>
    );
};

export const getErrors = (errorMessage: string | undefined): FormError[] => {
    if (!errorMessage) {
        return [];
    }

    try {
        const failures = JSON.parse(errorMessage);

        if (Array.isArray(failures)) {
            return failures
                .filter((failure) => !!failure.message)
                .map((failure) => {
                    return {
                        id: generateId(),
                        message: failure.message,
                        code: failure.code
                    };
                });
        }
    } catch {
        return [{ id: generateId(), message: errorMessage }];
    }

    return [];
};
